"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuButton_unstable", {
    enumerable: true,
    get: ()=>useMenuButton_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactIcons = require("@fluentui/react-icons");
const _reactUtilities = require("@fluentui/react-utilities");
const _index = require("../Button/index");
const useMenuButton_unstable = ({ menuIcon , ...props }, ref)=>{
    const buttonState = (0, _index.useButton_unstable)(props, ref);
    var _props_ariaexpanded;
    buttonState.root['aria-expanded'] = (_props_ariaexpanded = props['aria-expanded']) !== null && _props_ariaexpanded !== void 0 ? _props_ariaexpanded : false;
    return {
        // Button state
        ...buttonState,
        // State calculated from a set of props
        iconOnly: Boolean(!props.children),
        // Slots definition
        components: {
            root: 'button',
            icon: 'span',
            menuIcon: 'span'
        },
        menuIcon: (0, _reactUtilities.resolveShorthand)(menuIcon, {
            defaultProps: {
                children: /*#__PURE__*/ _react.createElement(_reactIcons.ChevronDownRegular, null)
            },
            required: true
        })
    };
}; //# sourceMappingURL=useMenuButton.js.map

//# sourceMappingURL=useMenuButton.js.map